import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
/**Local files */
import { homeValues, orders } from '../utils/index';
@Injectable()
export class ScheduleQueryService {
    homeValues: any;
    ordersValues = orders;

    private GET_ALLOCATED_ACCPETED_NEXT_ORDERS_DATA: any;
    private GET_ALLOCATED_ACCPETED_FIRST_ORDERS_DATA: any;
    private GET_ACCPETED_NEXT_ORDERS_DATA: any;
    private GET_ACCPETED_FIRST_ORDERS_DATA: any;
    private GET_REQUEST_BY_ORDER_ID: any;
    private GET_ALL_ORDERS_DATA: any;

    public UPDATE_SCHEDULE_REQUEST: any;

    constructor(public apollo: Apollo) {

        this.homeValues = homeValues;

        /*get all orders based on address*/
        this.GET_ALLOCATED_ACCPETED_NEXT_ORDERS_DATA = gql`
          query GetOrders($acceptedBy:UUID!,$cursor:Cursor!,$status:String!) {

            allScheduleRequests(orderBy:STATUS_CHANGE_AT_DESC,
            condition: {acceptedBy:$acceptedBy,acceptStatus:$status},
            first:5,
            after:$cursor) 
                {
                          edges {
                              node {                                       
                                  orderId
                                      startAt
                                      endAt
                                      scheduleRequestDate
                                      createdAt
                                      buyerProperty
                                      acceptStatus
                                      acceptedBy
                                      scheduleRequestId
                                      nodeId
                                      statusChangeAt
                                      inspectionReportsSrcByScheduleRequestId {        
                                        reportSolutionMastersByInsReportId(condition:{acceptStatus:true}) {
                                          edges {
                                            node {
                                              createdAt
                                              insReportId
                                              reviewId
                                              acceptStatus
                                              allocated
                                              orderId
                                              expectedDate
                                              buyerProperty
                                              reviewedBy
                                              reportReviewDetailByReviewId {
                                                categoryId
                                                subCategoryId                                              
                                                categoryName
                                                subCategoryName  
                                                totalCost                                          
                                            }
                                            }
                                          }
                                        }
                                    }
                                }
                                cursor
                            }
                            totalCount
                    pageInfo {
                        endCursor
                        hasNextPage
                    }
                }
           }
          `;

        /*get all orders based on address*/
        this.GET_ALLOCATED_ACCPETED_FIRST_ORDERS_DATA = gql`
  query GetOrders($acceptedBy:UUID!,$status:String!) {
      allScheduleRequests(orderBy:STATUS_CHANGE_AT_DESC,condition: {acceptedBy:$acceptedBy,acceptStatus:$status},first:5) 
        {
                  edges {
                      node {                                       
                          orderId
                              startAt
                              endAt
                              scheduleRequestDate
                              createdAt
                              buyerProperty
                              acceptStatus
                              acceptedBy
                              scheduleRequestId
                              nodeId
                              statusChangeAt
                              inspectionReportsSrcByScheduleRequestId {  
                                        
                                reportSolutionMastersByInsReportId(condition:{acceptStatus:true}) {
                                  edges {
                                    node {
                                      createdAt
                                      insReportId
                                      reviewId
                                      acceptStatus
                                      allocated
                                      orderId
                                      expectedDate
                                      buyerProperty
                                      reviewedBy
                                      reportReviewDetailByReviewId {
                                        categoryId
                                        subCategoryId                                              
                                        categoryName
                                        subCategoryName  
                                        totalCost                                          
                                    }
                                    }
                                  }
                                }
                            }
                        }
                        cursor
                    }
                    totalCount
                    pageInfo {
                        endCursor
                        hasNextPage
                    }
        }
   }
  `;

        /*get all orders based on address*/
        this.GET_ACCPETED_NEXT_ORDERS_DATA = gql`
   query GetOrders($acceptedBy:UUID!,$cursor:Cursor!,$statusAllocated:String!,$statusDeclined:String!) {

     allScheduleRequests(orderBy:ACCEPTED_DATE_DESC,
        filter:{
    acceptStatus:{
        notIn: [$statusAllocated,$statusDeclined]
    },
    acceptedBy:{
      equalTo:$acceptedBy
    }
    
  }
     first:5,
     after:$cursor) 
         {
                   edges {
                       node {                                       
                           orderId
                               startAt
                               endAt
                               scheduleRequestDate
                               createdAt
                               buyerProperty
                               acceptStatus
                               acceptedBy
                               scheduleRequestId
                               nodeId
                               acceptedDate
                               statusChangeAt
                               inspectionReportsSrcByScheduleRequestId {        
                                 reportSolutionMastersByInsReportId(condition:{acceptStatus:true}) {
                                   edges {
                                     node {
                                       createdAt
                                       insReportId
                                       reviewId
                                       acceptStatus
                                       allocated
                                       orderId
                                       expectedDate
                                       buyerProperty
                                       reviewedBy
                                       reportReviewDetailByReviewId {
                                         categoryId
                                         subCategoryId                                              
                                         categoryName
                                         subCategoryName  
                                         totalCost                                          
                                     }
                                     }
                                   }
                                 }
                             }
                         }
                         cursor
                     }
                     totalCount
             pageInfo {
                 endCursor
                 hasNextPage
             }
         }
    }
   `;

        /*get all orders based on address*/
        this.GET_ACCPETED_FIRST_ORDERS_DATA = gql`
query GetOrders($acceptedBy:UUID!,$statusAllocated:String!,$statusDeclined:String!) {
allScheduleRequests(orderBy:ACCEPTED_DATE_DESC,
    filter:{
    acceptStatus:{
        notIn: [$statusAllocated,$statusDeclined]
    },
    acceptedBy:{
      equalTo:$acceptedBy
    }
    }
first:5) 
 {
           edges {
               node {                                       
                   orderId
                       startAt
                       endAt
                       scheduleRequestDate
                       createdAt
                       buyerProperty
                       acceptStatus
                       acceptedBy
                       scheduleRequestId
                       nodeId
                       acceptedDate
                       statusChangeAt
                       inspectionReportsSrcByScheduleRequestId {  
                                 
                         reportSolutionMastersByInsReportId(condition:{acceptStatus:true}) {
                           edges {
                             node {
                               createdAt
                               insReportId
                               reviewId
                               acceptStatus
                               allocated
                               orderId
                               expectedDate
                               buyerProperty
                               reviewedBy
                               reportReviewDetailByReviewId {
                                 categoryId
                                 subCategoryId                                              
                                 categoryName
                                 subCategoryName  
                                 totalCost                                          
                             }
                             }
                           }
                         }
                     }
                 }
             }
             totalCount
             pageInfo {
                 endCursor
                 hasNextPage
             }
 }
}
`;
        /*Get node Id of selected Order from ScheduleRequests*/
        this.GET_REQUEST_BY_ORDER_ID =
            gql`     
                query currentScheduleRequests($orderId:Int){                           
                    allScheduleRequests(condition:{orderId:$orderId}) {
                    edges {
                    node {
                        orderId
                        nodeId                       
                        startAt
                        endAt
                        scheduleRequestDate
                        createdAt
                        buyerProperty
                        acceptStatus
                        acceptedBy
                        acceptedDate  
                        completedat          
                    }
                    }
                }  
                }
      `;
        /*Update ScheduleRequests by node id*/
        this.UPDATE_SCHEDULE_REQUEST =
            gql`                                
                mutation updatequery($input:UpdateScheduleRequestInput!){
                    updateScheduleRequest(input:$input){
                    scheduleRequest {
                    acceptStatus
                    }
                    }
                }   
                `;

    }

    /*Get allocated  orders -Avilable jobs*/
    GET_ALLOCATED_ACCPETED_ORDERS(userId, from, cursor, status): any {
        console.log('initial', from == 'initial')
        return this.apollo
            .watchQuery({
                query: from == 'initial' ? this.GET_ALLOCATED_ACCPETED_FIRST_ORDERS_DATA : this.GET_ALLOCATED_ACCPETED_NEXT_ORDERS_DATA
                ,
                variables:
                {
                    "acceptedBy": userId,
                    "cursor": cursor,
                    "status": status
                },
                fetchPolicy: 'network-only'
            });
    }
    /*Get after accepted orders - Jobs in progress*/
    GET_ALL_ORDERS(userId, from, cursor): any {
        return this.apollo
            .watchQuery({
                query: from == 'initial' ? this.GET_ACCPETED_FIRST_ORDERS_DATA : this.GET_ACCPETED_NEXT_ORDERS_DATA
                ,
                variables:
                {
                    "acceptedBy": userId,
                    "cursor": cursor,
                    "statusAllocated": this.ordersValues.storedStatus.Allocated,
                    "statusDeclined": this.ordersValues.storedStatus.Declined
                },
                fetchPolicy: 'network-only'
            });
    }

    /*Get node Id of selected Order from ScheduleRequests*/
    GET_REQUEST_STATUS_BY_ORDER_ID(orderId): any {
        return this.apollo
            .watchQuery({
                query: this.GET_REQUEST_BY_ORDER_ID
                ,
                variables:
                {
                    "orderId": orderId
                },
                fetchPolicy: 'network-only'
            });
    }
    /*Update ScheduleRequests by own user using node id*/
    UPDATE_REQUEST_STATUS(nodeId): any {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_REQUEST,
            variables: {
                "input": {
                    "scheduleRequestPatch":
                    {
                        "acceptStatus": this.ordersValues.storedStatus.Accepted,
                        "acceptedBy": window.localStorage.getItem('userUID'),
                        "acceptedDate": new Date(),
                        "statusChangeAt": new Date()
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }
    /*Update ScheduleRequests by own user using node id*/
    UPDATE_PROGRESS_STATUS(nodeId, status): any {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_REQUEST,
            variables: {
                "input": {
                    "scheduleRequestPatch":
                    {
                        "acceptStatus": status,
                        "statusChangeAt": new Date(),
                        "completedat": (status == this.ordersValues.storedStatus.Completed) ? new Date() : null
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })

    }

    /*Used for declined status with reason*/
    DECLINE_JOB(nodeId, reason): any {
        return this.apollo.mutate({
            mutation: this.UPDATE_SCHEDULE_REQUEST,
            variables: {
                "input": {
                    "scheduleRequestPatch":
                    {
                        "acceptStatus": this.ordersValues.storedStatus.Declined,
                        "declineReason": reason,
                        "statusChangeAt": new Date()
                    },
                    "nodeId": nodeId
                }
            },
            fetchPolicy: 'no-cache'
        })
    }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/scheduleRequest.ts